export enum OrganizationTemplateUsedFor {
  CONSULT_NOTE = 'consult_note',
  DOCUMENT = 'document',
}

export enum OrganizationTemplateChangedBy {
  EDITOR = 'editor',
  QUICK_ACTION = 'quick_action',
}
